/**
 * Accessibility remediation #106 - WCAG 1.3.1 Info and Relationships
 *
 * Links that open in a new tab must say so. Most of the offending links live in
 * content we cannot edit from the theme (product descriptions come from Shopify's
 * product database, the tracking page FAQ is rendered by Wonderment), so the
 * warning is appended at runtime to every in-content link that carries
 * target="_blank" and does not already announce the behaviour itself.
 */
(function () {
  'use strict';

  var NOTICE = ' (opens in a new tab)';
  var MARKER = 'data-a11y-new-tab';
  var ALREADY_ANNOUNCED = /new (tab|window)/i;

  function accessibleName(link) {
    return (link.getAttribute('aria-label') || link.textContent || '') + ' ' + (link.title || '');
  }

  function annotate(link) {
    if (link.hasAttribute(MARKER)) return;
    link.setAttribute(MARKER, '');

    if (ALREADY_ANNOUNCED.test(accessibleName(link))) return;

    // An aria-label replaces the link text entirely, so extend it rather than
    // appending a span the screen reader would never reach.
    var label = link.getAttribute('aria-label');
    if (label) {
      link.setAttribute('aria-label', label + NOTICE);
      return;
    }

    var notice = document.createElement('span');
    notice.className = 'visually-hidden';
    notice.textContent = NOTICE;
    link.appendChild(notice);
  }

  function scan(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches && root.matches('a[target="_blank"]')) annotate(root);
    var links = root.querySelectorAll ? root.querySelectorAll('a[target="_blank"]') : [];
    for (var i = 0; i < links.length; i++) annotate(links[i]);
  }

  function init() {
    // Scope to page content: third-party chat/consent widgets manage their own
    // markup and re-render often enough that patching them is churn, not a fix.
    var scopes = document.querySelectorAll('main, .shopify-section');
    for (var i = 0; i < scopes.length; i++) scan(scopes[i]);

    var main = document.querySelector('main');
    if (!main || !window.MutationObserver) return;

    new MutationObserver(function (mutations) {
      for (var m = 0; m < mutations.length; m++) {
        var added = mutations[m].addedNodes;
        for (var n = 0; n < added.length; n++) scan(added[n]);
      }
    }).observe(main, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
